import React, { use } from 'react';
import './DashboardHome.scss';
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import SalesBarChart from '../../../Components/SalesBarChart.jsx';
import chart from "../../../Assets/chart.png"
import user from "../../../Assets/icone-user.png"
import icon from "../../../Assets/sideicone.png"
import cart from "../../../Assets/iconcart.png"
import person from "../../../Assets/person.png"
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import gift from "../../../Assets/gift.png"
import { RiErrorWarningLine } from "react-icons/ri";

export default function DashboardHome() {
  
const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
};

  return (
    <div className='p-2'>

<div  className=' upper-part'>
  <div className='main-card'>
   <div className='card-header'>
   <div className=' d-flex align-items-center gap-4'>
   <select className='selected options'>
   <option defaultValue="thisMonth" className='options'>This Month</option>
   <option value="last24Hours" className='options'>Last 24 hours</option>
   <option value="thisWeek" className='options'>This Week</option>
   </select>
   <div className=' d-flex  align-items-start gap-2'>
   <div className='input-div'><span>vs</span> Same period previous month </div>

  <RiErrorWarningLine/>
  </div>
    </div>

   <img src={icon} width={40} height={40} alt="" />

  </div>
<div className='btn-line'></div>

  <div className='card-body'>

    <p className='Gross'>Gross Sales</p>
    <div className='spans'>
    <p>01 Jun - 13 Jun 2024 <span>$0.00</span></p>
    <p>01 Jun - 13 Jun 2024  <span>$0.00</span></p>
    </div>
    <div className='div3'>
    <div>
    <div className='min-div'>Sales</div>
    <div className='spans2'> 
       <span className='bold'>$20.4K</span>
      <span className='small'>+10.02%</span>
    </div>
    </div>

    <div>
    <div className='min-divblue'>Orders</div>
    <div className='spans2'> 
       <span className='bold'>$20.4K</span>
      <span className='small'>+10.02%</span>
    </div>
    </div>

    <div>
    <div className='min-div'>Avg Order Value</div>
    <div className='spans2'> 
       <span className='bold'>$20.4K</span>
      <span className='small'>+10.02%</span>
    </div>
    </div>
    </div>
  
    <div className='div4'>
    <div>
    <div className='min-divred'>Refunded</div>
    <div className='spans2'> 
       <span className='bold'>$20.4K</span>
      <span className='small'>+10.02%</span>
    </div>
    </div>

    <div>
    <div className='min-div'>Dicounts</div>
    <div className='spans2'> 
       <span className='bold'>$20.4K</span>
      <span className='small'>+10.02%</span>
    </div>
    </div>

    <div>
    <div className='min-divyell'>Abandonment Checkouts</div>
    <div className='spans2'> 
       <span className='bold'>$20.4K</span>
      <span className='small'>+10.02%</span>
    </div>
    </div>
    </div>
  </div>
</div>

  <div className='card2'>
<div className=' main-carddiv2 mb-3'> 
  <div className='sub-div'>

  <img src={user} width={30} height={30} alt="" style={{ objectFit: 'contain' }} />
  <div>
  <p className='Customers'>Customers</p>
  <div className='numbers'><h3>1,368</h3>
  <span>37.8%</span></div>
  </div>

  
</div>


<div className='sub-div2'>

<img src={cart} width={30} height={30} alt="" style={{ objectFit: 'contain' }} />
<div>
<p className='Customers'>Income</p>
<div className='numbers'><h3>68,192</h3>
<span>37.8%</span></div>
</div>


</div>

</div>

<div className='persons-part1  mb-5'>
  <p>Welcomes <span  style={{color:"black ", fontWeight:"bold"}}>291 customers</span>  with a <br /> personal message 😎</p>
  <button>Send message</button>
</div>
<div className=' persons '>
<div>
  <img src={person} width={70} alt="" />
  <span>Ahmed</span>
</div>

<div>
  <img src={person} width={70} alt="" />
  <span>Ahmed</span>
</div>

<div>
  <img src={person} width={70} alt="" />
  <span>Ahmed</span>
</div>

<div className='viewall'>
  <i className="fas fa-arrow-right"></i>
</div>

</div>






</div>
</div>



<div className='lower-part'>
<div className='main-card2'>
  <div className='card-header'>
   
<div>
<div className='side-upper'>
  <img src={chart} width={20}  height={20}  alt="" />
<p className='card-2'>Monthly Sales vs Orders</p>
</div>

<div className='divv'>
  
<div className='all-spans'>
  
  <div className='divspan1'>  <div className='span1'></div>Sales</div>
<div className='divspan1'>
<div className='span2'></div>Orders
</div>
  
</div>
  <select className='selected options mb-2'>
      <option defaultValue="thisMonth" className='options'>This Month</option>
      <option value="last24Hours" className='options'>Last 24 hours</option>
      <option value="thisWeek" className='options'>This Week</option>
    </select>
</div>
</div>


  </div>

<div className='btn-line'></div>

  <div className='card-body'>



<SalesBarChart />
  </div>
</div>


<div className=' d-flex main-card5 flex-column'>


 <div className='main-card4'>
  <div className='  d-flex justify-content-between mb-2'>
  <div className='card-header'>
    <select className='selected options'>
      <option defaultValue="thisMonth" className='options'>This Month</option>
      <option value="last24Hours" className='options'>Last 24 hours</option>
      <option value="thisWeek" className='options'>This Week</option>
    </select>

  </div>

   <img src={icon} width={40} height={40} alt="" />
  </div>

<div className='btn-line'></div>

  <div className='card-body'>

 
    <div className=' d-flex align-items-center gap-2'>
        <p className='m-0 p-0  text-black  '>PRODUCT SALES</p>
      <RiErrorWarningLine/>
    </div>

    <div className='div4'>
    <div>
      <div className=' d-flex flex-column align-items-center justify-content-center'>
   <div className='min-div'>Available Product Types</div>
    
       <span className='bold  fw-bold' style={{fontSize:"24px"}}>154</span>
      </div>
 
    </div>

    <div>
      <div className=' d-flex flex-column align-items-center justify-content-center'>
  <div className='min-divblue'>Purchace Frequency</div>
       <span className='bold  fw-bold' style={{fontSize:"24px"}}>1.44 </span>
      </div>
  

    </div>

    <div>
       <div className=' d-flex flex-column align-items-center justify-content-center'>
    <div className='min-div'>Avg Processing Hours</div>
        <span className='bold  fw-bold' style={{fontSize:"24px"}}>102.54</span>

       </div>

    </div>
    </div>
  </div>
</div> 

<div className='card-body2'>

  <p className='Recommended'>Recommended Add On's</p>
  <Slider {...settings}>
  <div >
    <div className="img-gift">
      <img src={gift} alt="gift" />
      <h2>Marketing</h2>
    </div>
    
  </div>
  <div >
    <p className='Gross'>Gross Sales - Slide 2</p>
    <p>$15.3K</p>
  </div>
  <div>
    <p className='Gross'>Gross Sales - Slide 3</p>
    <p>$18.1K</p>
  </div>
</Slider>

  </div>
</div>
</div>

  
    <div>

    
   </div>
      </div>




  );
}


